<div class="container-fluid g-0 m-0">
    <div class="row g-0 m-0 d-flex pt-5 align-items-center">
        <div class="col-md-1 d-flex pe-4 justify-content-end">
            <div class="button-back pb-3" [routerLink]="['/events/on-demand']">
                <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
            </div>
        </div>
        <div class="col-md-11">
            <h2 class="col pb-2 m-0 title">
                {{ "ONDEMANDENERGYREAD" | translate }}
            </h2>
            <p class="col subtitle">{{ "CONNDISCONNSETUP_SUBTITLE" | translate }}</p>
        </div>
    </div>
    <form #crudform="ngForm" (ngSubmit)="onSubmit()">
        <div class="form-item">
            <label class="form-label" for="meterNo">
                {{ "DEVICESETUP_METERNO" | translate }}
            </label>
            <div class="form-input">
                <input id="meterNo" [(ngModel)]="meterNo" #meterNoModel="ngModel"
                    name="meterNo" type="text" pattern="^[0-9]+$" required />
    
                <div *ngIf="crudform.submitted && meterNoModel.invalid">
                    {{ "DEVICESETUP_METERNO" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
                </div>
    
                <div *ngIf="meterNo.trim() === ''">
                    <div class="validation-instruction">
                        {{ "DEVICESETUP_METERNODESC" | translate }}
                    </div>
                </div>
    
                <div *ngIf="meterNoModel.invalid && meterNoModel.errors?.['pattern']">
                    <div class="validation-error">
                        {{ "METERNUMBER_ERROR" | translate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="horizontal-line"></div>
    
        <div class="form-item-button">
            <button class="button-submit" [disabled]="crudform.invalid" type="submit">
                {{ "CONTINUE" | translate }}
            </button>
        </div>
    </form>
    
    
</div>